import { api } from './api'

export const fetchPriceCategory = (query) => api.get('/price-category', query)
export const addPriceCategory = (price) => api.post('/price-category', price)
export const bulkUpdatePriceCategory = (allPriceCategory) => api.post('/price-category/bulk-update', allPriceCategory)
export const updatePriceCategory = (price) => api.put(`/price-category/${price.id}`, price)
export const deletePriceCategory = (price) => api.delete(`/price-category/${price.id}`)
